import { onBeforeUnmount } from 'vue';

/**
 * iOS WebView host apps can shift the page layout (toggle side panes, etc.)
 * by firing visualViewport.resize without firing window.resize. PrimeVue's
 * Popover positions its panel with absolute document coordinates that are
 * computed once on open, so it doesn't follow the trigger after a reflow.
 *
 * This wires a visualViewport.resize listener while the popover is open and
 * calls `realign` (typically `popoverRef.value?.alignOverlay()`) so the
 * panel re-snaps to the trigger's new position.
 *
 * Usage: bind onShow/onHide to the popover's @show / @hide events.
 */
export function useRealignOnViewportResize(realign: () => void) {
  const onResize = () => realign();

  const onShow = () => {
    window.visualViewport?.addEventListener('resize', onResize);
  };

  const onHide = () => {
    window.visualViewport?.removeEventListener('resize', onResize);
  };

  onBeforeUnmount(onHide);

  return { onShow, onHide };
}
